import API from "@services/root/rootApi";
import type {
  LocalReport,
  QuickSightCustomReport,
  QuickSightEmbedURL,
} from "./types";

export const deleteReports = async (ids: string[]): Promise<void> => {
  await API.delete(`/symphony-api/quicksight/byor`, {
    data: ids,
  });
};

export const getReportEmbeddedUrl = async (
  arn: string,
  custom?: boolean,
  design?: boolean
): Promise<QuickSightEmbedURL> => {
  let params: any = {};
  if (!custom) {
    params.arn = arn;
  }

  let response;
  let data: QuickSightEmbedURL;
  if (custom) {
    if (design)
      response = await API.get<QuickSightCustomReport>(
        `/symphony-api/quicksight/byor/design?id=${arn}`,
        params
      );
    else
      response = await API.get<QuickSightCustomReport>(
        `/symphony-api/quicksight/byor/view?id=${arn}`
      );
    data = {
      embeddedUrl: response.data.url,
      description: response.data.description,
      title: response.data.title,
    };
  } else {
    response = await API.post<QuickSightEmbedURL>(
      `/symphony-api/quicksight/generate-embedded-url`,
      params
    );
    data = response.data;
  }

  data.custom = custom;
  data.design = design;
  return data;
};

export const getLocalReports = async (): Promise<LocalReport[]> => {
  const response = await API.get<LocalReport[]>(
    `/symphony-api/quicksight/predefined-dashboards`
  );

  return response.data
    .sort((a, b) => (a.title || "").localeCompare(b.title || ""))
    .map((r) => {
      r.path = r.quicksightName ?? "";
      return r;
    });
};

export const getReports = async (): Promise<QuickSightCustomReport[]> => {
  const response = await API.get<QuickSightCustomReport[]>(
    `/symphony-api/quicksight/byor`
  );

  return response.data;
};

export const createReport = async (
  name: string,
  description: string
): Promise<QuickSightCustomReport> => {
  const response = await API.post<QuickSightCustomReport>(
    `symphony-api/quicksight/byor`,
    { title: name, description },
    {}
  );

  let tmp = {
    name: response.data.title,
    id: response.data.id,
    description: response.data.description,
  };
  return tmp as QuickSightCustomReport;
};

export const saveReport = async (
  id: string,
  name: string,
  description: string
): Promise<void> => {
  await API.put<QuickSightCustomReport>(`symphony-api/quicksight/byor`, {
    id: id,
    title: name,
    description: description,
  });
};

export const publishReport = async (arn: string) => {
  await API.post(`symphony-api/quicksight/byor/publish?id=${arn}`);
};
